"use strict";

exports.__esModule = true;
exports.Translator = void 0;
var _react = require("react");
var _reactIntl = require("react-intl");
var _class, _Translator;
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Translates messages and provides access to React Intl via a render prop.
 */
var Translator = exports.Translator = (0, _reactIntl.injectIntl)(_class = (_Translator = /*#__PURE__*/function (_Component) {
  function Translator() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(Translator, _Component);
  Translator.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.intl === prevState.intl) {
      return null;
    }
    return makeState(props);
  };
  var _proto = Translator.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return Translator;
}(_react.Component), _Translator.defaultProps = {
  intl: undefined
}, _Translator)) || _class;
function makeState(props) {
  var intl = props.intl;
  var translate = function translate(id, defaultMessage, values) {
    if (values === void 0) {
      values = {};
    }
    var descriptor = {
      id: id,
      defaultMessage: defaultMessage
    };
    return intl.formatMessage(descriptor, values);
  };
  return {
    intl: intl,
    translate: translate
  };
}